import $ from "jquery";
class Pagination {

    run() {
        this.pagination();
    }

    pagination() {
        /****** Tease Pagination*****/
        $(".tease-wrapper").slice(0, 9).show();
        $(".btn-load-more").on('click', function (e) {
            e.preventDefault();
            if ($('.category.active').length > 0 && $('.category.active')[0].innerHTML !== 'Tutto') {
                const cat = $('.category.active').text();

                $('[data-category="' + cat + '"]:hidden').parent().slice(0, 9).fadeIn(200);

                if ($('[data-category="' + cat + '"]:hidden').length == 0) {
                    $(".btn-load-more").fadeOut('slow');
                }
            } else {
                $(".tease-wrapper:hidden").slice(0, 9).fadeIn(200);
                if ($(".tease-wrapper:hidden").length == 0) {
                    $(".btn-load-more").fadeOut('slow');
                }
            };
        });
    }

}

const pagination = new Pagination();
export default pagination;
